<template>
  <tr>
    <td
      style="width: 25px;border-bottom: 0;text-align: center; vertical-align: middle;display:flex; align-items: center;flex-direction: column;"
    >
      <a
        v-if="listId && listId.id"
        roll="button"
        class="handle"
      >
        <v-icon small>drag_handle</v-icon>
      </a>
      <v-icon
        style="color: rgba(0,0,0,0.3);"
        :style="hovering ? 'color: rgba(255,0,0,0.3) !important;' : ''"
        @click="doDelete"
        @mouseover="hovering = true"
        @mouseleave="hovering = false"
      >
        {{hovering ? 'mdi-delete-empty' : 'mdi-delete-outline'}}
      </v-icon>
    </td>
    <td
      v-for="(subfieldtype, index) in fieldType.subfieldtypes"
      :key="subfieldtype.id"
      :style="{ width: colWidth + '%' }"
      style="position:relative;"
    >
      <AnswerField
        :userFormId="userFormId"
        :question="question"
        :fieldType="subfieldtype"
        :listId="listId"
        :isEmpty="isEmpty"
        :readOnly="deleting"
        @update:listId="$emit('update:listId', arguments[0])"
      />
    </td>
    <v-dialog
      v-model="deleteDialog"
      width="400"
      persistent
    >
      <v-card
        style="background: #F44336; color: white;"
      >
        <v-card-text
          style="text-align:center"
        >
          <v-icon
            color="white"
            size="92"
          >
            mdi-delete-empty
          </v-icon><br />
          Are you sure you want to delete this row? The answers in this row will be deleted.
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            small
            flat
            @click="doDelete"
          >
            Delete
          </v-btn>
          <v-spacer />
          <v-btn
            color="white"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </tr>
</template>

<script>
import AnswerField from './AnswerField'
import answerListMixin from '@/components/global/answerlistmixin'

export default {
  name: 'AnswerListTableRow',
  props: [ 'userFormId', 'question', 'fieldType', 'listId', 'colWidth' ],
  mixins: [ answerListMixin ],
  components: {
    AnswerField
  },
}
</script>

<style scoped>
  td {
    vertical-align: bottom;
    padding-right: 4px;
    border-bottom: rgba(0,0,0,0.2) 1px solid;
  }
</style>
